import { PHONE_CASES_CATEGORIES_MENU_CONFIG } from 'constants/categoriesMenu';
import { TCategoriesMenuItem } from './CategoriesMenu.types';

export const CATEGORIES_MENU_CONFIG: Array<TCategoriesMenuItem> = [
  PHONE_CASES_CATEGORIES_MENU_CONFIG,
];
